module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope) ? _c('div', [_c('lesson-inline-grid'), _vm._v(" "), _c('div', {
    staticClass: "dashboard-patients"
  }, [(_vm.showTips) ? _c('div', {
    staticClass: "tip-details"
  }, [_c('carousel', {
    attrs: {
      "paginationEnabled": false,
      "perPage": 1,
      "navigationEnabled": true,
      "loop": true,
      "navigationPrevLabel": "<img src='static/dashboard/chevron-left.svg'/>",
      "navigationNextLabel": "<img src='static/dashboard/chevron-right.svg'/>"
    }
  }, _vm._l((_vm.tipsList), function(item, index) {
    return _c('slide', {
      key: ("tip-" + index),
      staticClass: "text item"
    }, [_c('mu-icon', {
      attrs: {
        "value": "info"
      }
    }), _vm._v(" "), _c('h2', [_vm._v("Tip " + _vm._s(index + 1) + " of " + _vm._s(_vm.tipsList.length) + ": "), _c('span', [_vm._v(_vm._s(item.tip))])])], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    on: {
      "click": function($event) {
        return _vm.openGettingStarted()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("How to get started:")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.gettingStarted ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.gettingStarted) ? _c('div', {
    staticClass: "getting-started"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_vm._l((_vm.startedData), function(item, index) {
    return (_vm.showStarted) ? _c('mu-col', {
      key: ("started-data-" + index),
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "25"
      }
    }, [_c('mu-card', {
      staticClass: "started-block",
      class: item.category
    }, [_c('mu-avatar', [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": item.title
      }
    })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('mu-raised-button', {
      attrs: {
        "label": item.cta
      },
      on: {
        "click": function($event) {
          return _vm.gettingStartedPush(item)
        }
      }
    })], 1)], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((4), function(item) {
    return (!_vm.showStarted) ? _c('mu-col', {
      key: ("dummy-started-loader-" + item),
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "25"
      }
    }, [_c('mu-card', {
      staticClass: "started-loader"
    }, [_c('div', {
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "img"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "title"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "text"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "btn"
    })], 1)])], 1) : _vm._e()
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    on: {
      "click": function($event) {
        return _vm.openMyLessons()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("My lessons")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.myLessons ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.myLessons) ? _c('div', {
    staticClass: "lessons-block"
  }, [(_vm.showLesson) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "30"
    }
  }, [_c('div', {
    staticClass: "lessons"
  }, [_c('h2', [_vm._v("This week's lesson:")]), _vm._v(" "), _c('div', {
    staticClass: "lesson-module",
    style: ({
      backgroundImage: 'url(' + _vm.currentLesson.image_url + ')'
    }),
    on: {
      "click": function($event) {
        return _vm.goToCurrentLesson()
      }
    }
  }, [_c('div', {
    staticClass: "lesson-text"
  }, [_c('h3', [_vm._v(_vm._s(_vm.currentLesson.week_name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentLesson.title))])]), _vm._v(" "), _c('div', {
    staticClass: "lesson-play"
  }, [_c('img', {
    attrs: {
      "src": "static/dashboard/play-large.svg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "70"
    }
  }, [_c('div', {
    staticClass: "downloads"
  }, [_c('h2', [_vm._v("This week's downloads")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_vm._l((_vm.downloads), function(item, index) {
    return _c('mu-col', {
      key: ("download-" + index),
      staticClass: "download-module",
      style: ({
        backgroundImage: 'url(' + item.image_url + ')'
      }),
      attrs: {
        "width": "100",
        "tablet": "33",
        "desktop": "33"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.downloadResource(item)
        }
      }
    }, [_c('div', {
      staticClass: "download-text"
    }, [_c('h3', [_vm._v(_vm._s(item.title))])])])
  }), _vm._v(" "), _c('mu-col', {
    staticClass: "download-module",
    style: ({
      backgroundImage: 'url(' + _vm.downloadsBg + ')'
    }),
    attrs: {
      "width": "100",
      "tablet": "33",
      "desktop": "33"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToDownloads()
      }
    }
  }, [_c('div', {
    staticClass: "allDownloads"
  }, [_c('div', {
    staticClass: "download-inner"
  }, [_c('mu-icon', {
    attrs: {
      "value": "get_app"
    }
  }), _vm._v(" "), _c('span', [_vm._v("View all downloads")])], 1)])])], 2)], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.showLesson) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "30"
    }
  }, [_c('div', {
    staticClass: "lessons"
  }, [_c('h2', [_vm._v("This week's lesson:")]), _vm._v(" "), _c('div', {
    staticClass: "lesson-module"
  }, [_c('div', {
    staticClass: "dummy"
  }, [_c('mu-linear-progress', {
    staticClass: "img"
  })], 1)])])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "70"
    }
  }, [_c('div', {
    staticClass: "downloads"
  }, [_c('h2', [_vm._v("This week's downloads:")]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((3), function(i) {
    return _c('mu-col', {
      key: ("download-module-dummy-" + i),
      staticClass: "download-module",
      attrs: {
        "width": "100",
        "tablet": "33",
        "desktop": "33"
      }
    }, [_c('div', {
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      key: i,
      staticClass: "img"
    })], 1)])
  }), 1)], 1)])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    on: {
      "click": function($event) {
        return _vm.openTodaysMeals()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("Today's meals")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.todaysMeals ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.todaysMeals) ? _c('div', {
    staticClass: "meals"
  }, [(_vm.recipesLoader) ? _c('div', {
    staticClass: "dummyLoader"
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "33",
      "desktop": "33"
    }
  }, [_c('div', {
    staticClass: "dummy"
  }, [_c('mu-linear-progress', {
    staticClass: "img"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "title"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "text"
  })], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "33",
      "desktop": "33"
    }
  }, [_c('div', {
    staticClass: "dummy"
  }, [_c('mu-linear-progress', {
    staticClass: "img"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "title"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "text"
  })], 1)]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "33",
      "desktop": "33"
    }
  }, [_c('div', {
    staticClass: "dummy"
  }, [_c('mu-linear-progress', {
    staticClass: "img"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "title"
  }), _vm._v(" "), _c('mu-linear-progress', {
    staticClass: "text"
  })], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.recipesLoader) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_vm._l((_vm.recipes), function(item, index) {
    return _c('mu-col', {
      key: ("recipe-" + index),
      attrs: {
        "width": "100",
        "tablet": "100",
        "desktop": "33"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "recipe-card recipe-block"
    }, [(index === 0 && item.id) ? _c('mu-float-button', {
      staticClass: "refresh",
      attrs: {
        "icon": "refresh"
      },
      on: {
        "click": function($event) {
          return _vm.getBreakfast()
        }
      }
    }) : _vm._e(), _vm._v(" "), (index === 1 && item.id) ? _c('mu-float-button', {
      staticClass: "refresh",
      attrs: {
        "icon": "refresh"
      },
      on: {
        "click": function($event) {
          return _vm.getLunch()
        }
      }
    }) : _vm._e(), _vm._v(" "), (index === 2 && item.id) ? _c('mu-float-button', {
      staticClass: "refresh",
      attrs: {
        "icon": "refresh"
      },
      on: {
        "click": function($event) {
          return _vm.getDinner()
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.photoLargeUri) ? _c('img', {
      attrs: {
        "src": item.photoLargeUri,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.goToRecipe(item.id)
        }
      }
    }) : _c('div', {
      staticClass: "no-image",
      on: {
        "click": function($event) {
          return _vm.goToRecipe(item.id)
        }
      }
    }, [_c('span', [_vm._v("No image available")])]), _vm._v(" "), (index === 0) ? _c('p', [_vm._v("Breakfast")]) : _vm._e(), _vm._v(" "), (index === 1) ? _c('p', [_vm._v("Lunch")]) : _vm._e(), _vm._v(" "), (index === 2) ? _c('p', [_vm._v("Dinner")]) : _vm._e(), _vm._v(" "), _c('h2', {
      on: {
        "click": function($event) {
          return _vm.goToRecipe(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.rating) ? _c('recipe-rating', {
      staticStyle: {
        "margin-bottom": "24px"
      },
      attrs: {
        "read-only": true,
        "count": item.rating.ratingCount,
        "rating": item.rating.ratingScore,
        "recipe": item
      }
    }) : _vm._e()], 1) : _c('div', {
      staticClass: "recipe-load"
    }, [_c('div', {
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "img"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "title"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "text"
    })], 1)])])
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('div', {
    staticClass: "recipes-banner"
  }, [_c('banner-block', {
    attrs: {
      "path": "/310087275/LCP_730x100",
      "size": [730, 100],
      "id": "div-gpt-ad-1585223997152-0"
    }
  })], 1)])], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    on: {
      "click": function($event) {
        return _vm.openPersonalised()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("Just for you")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.justForYou ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.justForYou) ? _c('div', {
    staticClass: "personalised"
  }, [(_vm.articlesLoader) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_vm._l((_vm.articles), function(item, index) {
    return _c('mu-col', {
      key: ("article-" + index),
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "20"
      }
    }, [_c('div', {
      staticClass: "article",
      on: {
        "click": function($event) {
          return _vm.goToArticle(item)
        }
      }
    }, [_c('div', {
      staticClass: "likes"
    }, [_c('mu-icon', {
      attrs: {
        "value": "favorite"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.post_favourites))])], 1), _vm._v(" "), _c('div', {
      staticClass: "image-wrap",
      style: ({
        background: 'url(' + item.post_image + ') center center'
      })
    }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(item.post_title))])])])
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "20"
    }
  }, [_c('div', {
    staticClass: "article"
  }, [_c('div', {
    staticClass: "image-wrap",
    style: ({
      background: 'url(' + this.lifestyleBg + ') center center'
    }),
    on: {
      "click": function($event) {
        return _vm.goToLifestyle()
      }
    }
  }, [_c('div', {
    staticClass: "lifestyle"
  }, [_c('mu-icon', {
    attrs: {
      "value": "local_florist"
    }
  }), _vm._v(" "), _c('span', [_vm._v("View Lifestyle")])], 1)])])])], 2) : _vm._e(), _vm._v(" "), (!_vm.articlesLoader) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((4), function(i) {
    return _c('mu-col', {
      key: ("articles-dummy-loader-" + i),
      attrs: {
        "width": "100",
        "tablet": "50",
        "desktop": "25"
      }
    }, [_c('div', {
      staticClass: "article"
    }, [_c('div', {
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "img"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticClass: "title"
    })], 1)])])
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    on: {
      "click": function($event) {
        return _vm.openCommunity()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("Trending in the community")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.community ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.community) ? _c('div', {
    staticClass: "community"
  }, [(_vm.communityLoader) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "align-motivated",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "30"
    }
  }, [_c('div', {
    staticClass: "motivated",
    on: {
      "click": function($event) {
        return _vm.goToCommunity()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/dashboard/community-general.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "motivated-btn"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "Ask our community"
    }
  })], 1)])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "70"
    }
  }, [_c('mu-row', {
    staticClass: "discussion-row",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, _vm._l((_vm.discussions[0]), function(item, index) {
    return _c('mu-card', {
      key: ("discussion-item-" + index),
      nativeOn: {
        "click": function($event) {
          return _vm.goToDiscussion(item)
        }
      }
    }, [_c('h2', {
      domProps: {
        "innerHTML": _vm._s(item.question)
      }
    }), _vm._v(" "), _c('mu-list-item', {
      attrs: {
        "title": item.display_name,
        "disabled": ""
      }
    }, [(item.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.profile_large
      },
      slot: "left"
    }) : _c('mu-avatar', {
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [_vm._v(_vm._s(_vm.upperTwoInitials(item.display_name)))])], 1), _vm._v(" "), _c('mu-row', {
      attrs: {
        "gutter": ""
      }
    }, [_c('mu-col', {
      attrs: {
        "width": "40",
        "tablet": "50",
        "desktop": "40"
      }
    }, [_c('div', {
      staticClass: "replies"
    }, [_c('mu-icon', {
      attrs: {
        "value": "reply"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.replies) + " replies")])], 1)]), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "60",
        "tablet": "50",
        "desktop": "60"
      }
    }, [_c('div', {
      staticClass: "created"
    }, [_c('mu-icon', {
      attrs: {
        "value": "access_time"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(item.timestamp)))])], 1)])], 1), _vm._v(" "), _c('img', {
      staticClass: "quote",
      attrs: {
        "src": "static/quote.svg",
        "alt": ""
      }
    })], 1)
  }), 1), _vm._v(" "), _c('mu-col', {
    staticClass: "spaceArticle",
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, _vm._l((_vm.discussions[1]), function(item, index) {
    return _c('mu-card', {
      key: ("discusstion-item-2-" + index),
      nativeOn: {
        "click": function($event) {
          return _vm.goToDiscussion(item)
        }
      }
    }, [_c('h2', [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('mu-list-item', {
      attrs: {
        "title": item.display_name,
        "disabled": ""
      }
    }, [(item.profile_large) ? _c('mu-avatar', {
      attrs: {
        "slot": "left",
        "src": item.profile_large
      },
      slot: "left"
    }) : _c('mu-avatar', {
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [_vm._v(_vm._s(_vm.upperTwoInitials(item.display_name)))])], 1), _vm._v(" "), _c('mu-row', {
      attrs: {
        "gutter": ""
      }
    }, [_c('mu-col', {
      attrs: {
        "width": "40",
        "tablet": "50",
        "desktop": "40"
      }
    }, [_c('div', {
      staticClass: "replies"
    }, [_c('mu-icon', {
      attrs: {
        "value": "reply"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.replies) + " replies")])], 1)]), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "60",
        "tablet": "50",
        "desktop": "60"
      }
    }, [_c('div', {
      staticClass: "created"
    }, [_c('mu-icon', {
      attrs: {
        "value": "access_time"
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(item.timestamp)))])], 1)])], 1), _vm._v(" "), _c('img', {
      staticClass: "quote",
      attrs: {
        "src": "static/quote.svg",
        "alt": ""
      }
    })], 1)
  }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.communityLoader) ? _c('mu-row', {
    staticClass: "loader",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "align-motivated",
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "30"
    }
  }, [_c('div', {
    staticClass: "motivated"
  }, [_c('div', {
    staticClass: "dummy"
  }, [_c('mu-linear-progress', {
    staticClass: "img"
  })], 1)])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "70"
    }
  }, [_c('mu-row', {
    staticClass: "discussion-row",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, _vm._l((2), function(item, index) {
    return _c('div', {
      key: ("discussion-dummy-row-" + index),
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "card"
    })], 1)
  }), 0), _vm._v(" "), _c('mu-col', {
    staticClass: "spaceArticle",
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, _vm._l((2), function(item, index) {
    return _c('div', {
      key: ("discussion-dummy-row-2-" + index),
      staticClass: "dummy"
    }, [_c('mu-linear-progress', {
      staticClass: "card"
    })], 1)
  }), 0)], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "trackHealth"
    },
    on: {
      "click": function($event) {
        return _vm.openTrackers()
      }
    }
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_c('h2', [_vm._v("Track your health")])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": _vm.trackHealth ? 'remove' : 'expand_more'
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.trackHealth) ? _c('cards') : _vm._e(), _vm._v(" "), _c('DisplayNameModal', {
    attrs: {
      "display": !_vm.$store.state.user.scope.accepted_display_name
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3caae317","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Patient.vue
// module id = 3130
// module chunks = 1